import React from 'react';
import Acord25Form from './Acord25Form';
import type { Acord25FormRef } from './Acord25Form';

export type { Acord25FormRef };

// Every prop the plain form takes, minus the one this wrapper sets. Spreading them keeps the
// "+ ACORD 101" variant in lockstep with the base form: before this, the wrapper re-listed the
// props by hand and silently dropped onLoadingChange, onCoverageMapping and friends, so on a
// +101 form the parent never learned which policies mapped (every policy looked unmapped) and
// the Loading state could never clear.
type Acord25With101FormProps = Omit<React.ComponentPropsWithoutRef<typeof Acord25Form>, 'showAcord101'>;

const Acord25With101Form = React.forwardRef<Acord25FormRef, Acord25With101FormProps>(
  function Acord25With101Form(props, ref) {
    return <Acord25Form ref={ref} showAcord101 {...props} />;
  }
);

export default Acord25With101Form;
